import React from "react";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import { useStore } from "../../store/store.context";
import { DONUT_CHART_COLORS } from "../../constants/constants";

import "./donut-chart.scss";

const DonutChart = ({ donutData }) => {
  const { updateStore, store } = useStore();

  const onUpdateTableData = (legend) => {
    const lower = legend.toLowerCase();
    const normalizedStatus =
      lower === "non compliant" ? "non-compliant" :
      lower === "non afr" ? "non-afr" :
      lower;
    
    // Toggle functionality: if the clicked status is already selected, deselect it
    const newStatus = store.dashboardStatus === normalizedStatus ? "" : normalizedStatus;
    
    updateStore({
      dashboardStatus: newStatus,
    });
  };

  const renderCells = (data) => {
    return data.map((legend, index) => (
      <Cell
        className="donut-cell"
        key={`cell-${index}`}
        fill={DONUT_CHART_COLORS[legend.name] || "#8884d8"}
      />
    ));
  };

  return (
    <div className="donut-chart-container">
      <PieChart width={360} height={255}>
        <Pie
          data={donutData}
          dataKey="value"
          nameKey="name"
          label
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={75}
          paddingAngle={2}
          labelLine={true}
          onClick={(e) => onUpdateTableData(e.name)}
        >
          {renderCells(donutData)}
        </Pie>
        <Tooltip />
        <Legend
          layout="vertical"
          verticalAlign="middle"
          align="right"
          onClick={(e) => onUpdateTableData(e.value)}
          wrapperStyle={{ right: "-25px", cursor: "pointer", fontSize: "11px" }}
        />
      </PieChart>
    </div>
  );
};

export default DonutChart;
